module.exports = __webpack_public_path__ + "static/media/return.aa4991db.mov";


//////////////////
// WEBPACK FOOTER
// ./src/videos/return.mov
// module id = 390
// module chunks = 0